/**
 * Util to check if the meeting type is default meeting type
 */
import store from '../store/Store';
import isFeatureEnabled from 'owa-feature-flags/lib/utils/isFeatureEnabled';

export const DEFAULT_MEETING_TYPE = '09705449-c7ee-4131-b1b9-3e961b18baf2'; // default 30 minutes meeting
const DEFAULT_MEETING_15 = '15 minutes meeting';
const DEFAULT_MEETING_30 = '30 minutes meeting';
const DEFAULT_MEETING_OFFICE_HOURS = 'Office hours';

export default function isDefaultMeetingType(meetingTypeId: string | undefined): boolean {
    const meetingType =
        store.meetingTypes && meetingTypeId ? store.meetingTypes.get(meetingTypeId) : undefined;
    return meetingType
        ? isFeatureEnabled('bookwithme-c1B2Migration')
            ? meetingType?.DisplayName === DEFAULT_MEETING_15 ||
              meetingType?.DisplayName === DEFAULT_MEETING_30
            : meetingType?.DisplayName === DEFAULT_MEETING_OFFICE_HOURS
        : false;
}
